/* Tile 组件 - 使用上传的 SVG 牌图 + 程序化牌身/边框 */

const T = window.MJ;

// 资源映射：内部 id -> 文件名
function tileFile(tile) {
  if (tile === 'back' || tile === 'ura') return 'back.svg';
  if (tile === 'free') return null;
  return tile + '.svg';
}

function TileImg({ tile, size = 36, variant = 'face', dim = false, glow = false, dora = false, accent = '#a93226', faceColor = '#fdfaf0', frameColor = '#bfb497', borderColor = '#7a6f56', onClick, style }) {
  const isFree = tile === 'free';
  const isBack = tile === 'back' || tile === 'ura';

  const W = 60, H = 84;
  const w = variant === 'h' ? size * H/W : size;
  const h = variant === 'h' ? size : size * H/W;

  const file = tileFile(tile);

  return (
    <div onClick={onClick}
      style={{
        width: w, height: h,
        cursor: onClick ? 'pointer' : 'default',
        opacity: dim ? 0.35 : 1,
        flex: 'none',
        position: 'relative',
        display: 'inline-block',
        ...(style || {})
      }}>
      <div style={{
        position: 'absolute', inset: 0,
        background: isBack ? '#2d4a3a' : faceColor,
        border: `1px solid ${borderColor}`,
        borderRadius: Math.max(3, size * 0.1),
        boxShadow: glow
          ? `0 0 0 2px ${accent}, 0 0 8px ${accent}aa, inset 0 1px 0 rgba(255,255,255,.6)`
          : `inset 0 1px 0 rgba(255,255,255,.6), 0 1px 2px rgba(0,0,0,.15), 0 -1px 0 ${frameColor} inset`,
        transform: variant === 'h' ? 'rotate(-90deg)' : 'none',
        transformOrigin: 'center',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute', left: 0, right: 0, bottom: 0,
          height: '6%',
          background: `linear-gradient(180deg, ${frameColor}88, ${frameColor})`,
        }}></div>
        {!isFree && file && (
          <img
            src={`/jsq/tiles/${file}`}
            draggable={false}
            style={{
              position: 'absolute',
              left: '12%', right: '12%', top: '8%', bottom: '12%',
              width: '76%', height: '80%',
              objectFit: 'contain',
              userSelect: 'none',
              pointerEvents: 'none',
            }}
          />
        )}
      </div>
      {dora && (
        <span style={{
          position:'absolute', top:-3, right:-3, width:12, height:12,
          background:'#9a7d2e', color:'#fdfaf0', fontSize:8, fontWeight:700,
          borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center',
          fontFamily:'serif', boxShadow:'0 1px 2px rgba(0,0,0,.3)', zIndex: 2
        }}>宝</span>
      )}
    </div>
  );
}

window.Tile = TileImg;
